var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphQl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38361 20.7831L6.26465 21.2917L16.0798 4.29196L15.1987 3.78328L5.38361 20.7831Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8121 19.4249H5.18182V20.4423H24.8121V19.4249Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5703 19.9965L15.3891 25.6655L15.8978 24.7845L6.07899 19.1154L5.5703 19.9965Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 5.22145L23.9186 10.8905L24.4273 10.0095L14.6085 4.34041L14.0998 5.22145Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57298 10.0056L6.08167 10.8867L15.9005 5.21761L15.3918 4.33657L5.57298 10.0056Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9225 4.29209L23.7376 21.2919L24.6186 20.7832L14.8035 3.7834L13.9225 4.29209Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97757 9.33093H5.96021V20.669H6.97757V9.33093Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0399 9.33093H23.0225V20.669H24.0399V9.33093Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7716 24.4653L15.2159 25.2349L23.7556 20.3044L23.3112 19.5348L14.7716 24.4653Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3882 21C24.7998 22.0235 23.4883 22.3728 22.4648 21.7845C21.4413 21.1961 21.092 19.8846 21.6803 18.8611C22.2687 17.8376 23.5802 17.4883 24.6037 18.0766C25.6333 18.6711 25.9827 19.9765 25.3882 21Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3136 11.1389C7.72524 12.1624 6.4137 12.5118 5.39021 11.9234C4.36671 11.335 4.01738 10.0235 4.60573 9.00001C5.19409 7.97651 6.50563 7.62718 7.52912 8.21553C8.55262 8.81002 8.90195 10.1154 8.3136 11.1389Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6119 21C4.02354 19.9765 4.37288 18.6711 5.39637 18.0766C6.41986 17.4883 7.72528 17.8376 8.31976 18.8611C8.90812 19.8846 8.55878 21.19 7.53529 21.7845C6.50566 22.3728 5.20025 22.0235 4.6119 21Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6864 11.1389C21.0981 10.1154 21.4474 8.81002 22.4709 8.21553C23.4944 7.62718 24.7998 7.97651 25.3943 9.00001C25.9826 10.0235 25.6333 11.3289 24.6098 11.9234C23.5863 12.5118 22.2748 12.1624 21.6864 11.1389Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 27C13.8172 27 12.8611 26.0439 12.8611 24.8611C12.8611 23.6782 13.8172 22.7222 15.0001 22.7222C16.1829 22.7222 17.139 23.6782 17.139 24.8611C17.139 26.0378 16.1829 27 15.0001 27Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 7.27783C13.8172 7.27783 12.8611 6.32176 12.8611 5.13892C12.8611 3.95608 13.8172 3 15.0001 3C16.1829 3 17.139 3.95608 17.139 5.13892C17.139 6.32176 16.1829 7.27783 15.0001 7.27783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphQl);
export default __webpack_public_path__ + "static/media/GraphQL.d39a93552d581b7f0f78d774872c664b.svg";
export { ForwardRef as ReactComponent };